module.exports = __webpack_public_path__ + "static/probanner-mob.8e829141.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/probanner-mob.jpg
// module id = 931
// module chunks = 118785002076118